module.exports = function() {
    $(document).ready(function () {

        var helper = require('./helper');
        var AjaxController = require('./services/AjaxController');


        $( "#sortable" ).sortable({
            axis: 'y',
            handle: 'td:first',
            start: function(event, ui) {
                var start_pos = ui.item.index();
                ui.item.data('start_pos', start_pos);
            },
            update: function (event, ui) {
                var url = "/api/properties/rooms/sort";
                var property_id = $('#property_id').attr('data-property-id');
                var order = [];

                $('#sortable tr').each( function(e) {
                    var obj = new Object();
                    obj.roomId =  $(this).attr('data-id');
                    obj.position =  $(this).index()+1;

                    order.push( JSON.stringify(obj) );
                });

                var data = {
                    'order': order,
                    'property_id' : property_id
                }

                var success = function (response) {
                }

                var error = function (response) {
                    console.log('Error');
                }

                AjaxController.prototype.send(url, data, success, error);
            }
        });

    });
}();